import { Form, Input, Modal, ModalProps, notification } from 'antd'
import { useEffect } from 'react'
import { useCreateServiceMutation } from 'services/authz'

interface Props extends ModalProps {
  onClose: (withRefresh: boolean) => void
}
export default function CreateNewGroup({ onClose, ...props }: Props) {
  const [form] = Form.useForm<{ name: string; description: string }>()

  const [createService, { isLoading, data, error }] = useCreateServiceMutation()

  useEffect(() => {
    if (!data?.errors && data?.data.name) {
      notification.success({
        message: 'Success',
        description: `Successfully created service ${data?.data.name}`,
      })
      onClose(true)
    }
  }, [data, onClose])

  useEffect(() => {
    if (error) {
      notification.error({
        message: 'Error',
        description: (error as any)?.data?.errors?.detail,
      })
    }
  }, [error])

  const onFinish = ({
    name,
    description,
  }: {
    name: string
    description: string
  }) => {
    createService({ name, description })
  }
  return (
    <Modal
      title="Create new service"
      centered
      okText="Create"
      onCancel={() => onClose(false)}
      okButtonProps={{ htmlType: 'submit', loading: isLoading }}
      onOk={form.submit}
      {...props}
    >
      <Form layout="vertical" onFinish={onFinish} form={form}>
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Please input service name' }]}
        >
          <Input placeholder="Service name..." />
        </Form.Item>
        <Form.Item
          name="description"
          label="Description"
          rules={[
            { required: true, message: 'Please input service description' },
          ]}
        >
          <Input placeholder="Service description..." />
        </Form.Item>
      </Form>
    </Modal>
  )
}
